import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.rowData.member_legislators.length && _vm.rowData.primary_kp.cell)?_c(VLayout,{attrs:{"align-center":""}},[_c('span',[_vm._v(" "+_vm._s(_vm.rowData.primary_kp.cell)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }